import React from 'react';
import { motion } from 'framer-motion';
import { Target, Heart, Compass, Users, UserCircle2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
const roles = [{
  title: 'Fasilitator',
  description: 'Memfasilitasi perkembangan peserta didik melalui penyediaan lingkungan yang kondusif dan program bimbingan yang relevan dengan kebutuhan siswa.',
  icon: Users,
  color: 'bg-pastel-blue-light'
}, {
  title: 'Pembimbing',
  description: 'Memberikan arahan dan panduan kepada siswa dalam menghadapi berbagai tantangan akademik, pribadi, sosial, maupun karier.',
  icon: Compass,
  color: 'bg-pastel-pink-light'
}, {
  title: 'Konselor Sekolah',
  description: 'Memberikan layanan konseling profesional untuk membantu siswa menyelesaikan masalah dan mencapai kesejahteraan psikologis (well-being).',
  icon: Heart,
  color: 'bg-pastel-grey-light'
}];
const teachers = [{
  name: 'Dra. Hj. Siti Aminah, M.Pd',
  role: 'Koordinator BK'
}, {
  name: 'Budi Santoso, S.Pd',
  role: 'Guru BK Kelas X'
}, {
  name: 'Rina Wati, S.Psi',
  role: 'Guru BK Kelas XI'
}, {
  name: 'Ahmad Fauzi, M.Pd',
  role: 'Guru BK Kelas XII'
}];
export function Profil() {
  const {
    user
  } = useAuth();
  return <div className="min-h-screen bg-white py-12" data-id="element-513">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-514">
        {/* 🔥 PROFIL USER */}
        {user && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16 max-w-3xl mx-auto bg-pastel-grey-light p-6 rounded-3xl shadow-sm" data-id="element-515">
            <div className="flex items-center gap-4" data-id="element-516">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-517">
                <UserCircle2 size={32} className="text-gray-400" data-id="element-518" />
              </div>

              <div data-id="element-519">
                <h2 className="text-xl font-bold text-dark" data-id="element-520">Profil Saya</h2>
                <p className="text-gray-600 text-sm" data-id="element-521">Email: {user.email}</p>
              </div>
            </div>
          </motion.div>}

        {/* HEADER */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-522">
          <h1 className="text-4xl font-bold text-dark mb-6" data-id="element-523">
            Profil Bimbingan & Konseling
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-524">
            Website Bimbingan dan Konseling ini hadir sebagai inovasi layanan
            digital untuk mempermudah akses siswa terhadap layanan BK. Kami
            berkomitmen untuk mendampingi setiap langkah perkembangan peserta
            didik menuju masa depan yang gemilang.
          </p>
        </motion.div>

        {/* VISI MISI */}
        <div className="grid md:grid-cols-2 gap-8 mb-24" data-id="element-525">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-pastel-blue-light/50 border border-pastel-blue" data-id="element-526">
            <div className="flex items-center gap-4 mb-6" data-id="element-527">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center" data-id="element-528">
                <Target className="text-blue-600" data-id="element-529" />
              </div>
              <h2 className="text-2xl font-bold text-dark" data-id="element-530">Visi</h2>
            </div>
            <p className="text-gray-700" data-id="element-531">
              Mewujudkan layanan Bimbingan dan Konseling yang profesional,
              inovatif, dan komprehensif untuk memfasilitasi perkembangan
              kemandirian peserta didik.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-pastel-pink-light/50 border border-pastel-pink" data-id="element-532">
            <div className="flex items-center gap-4 mb-6" data-id="element-533">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center" data-id="element-534">
                <Compass className="text-pink-600" data-id="element-535" />
              </div>
              <h2 className="text-2xl font-bold text-dark" data-id="element-536">Misi</h2>
            </div>
            <ul className="space-y-3 text-gray-700" data-id="element-537">
              <li data-id="element-538">• Layanan BK yang memandirikan siswa</li>
              <li data-id="element-539">• Kolaborasi dengan stakeholder sekolah</li>
              <li data-id="element-540">• Inovasi berbasis teknologi</li>
            </ul>
          </motion.div>
        </div>

        {/* PERAN BK */}
        <div className="mb-24" data-id="element-541">
          <div className="text-center mb-12" data-id="element-542">
            <h2 className="text-3xl font-bold text-dark mb-4" data-id="element-543">Peran Guru BK</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-544">
            {roles.map((role, index) => {
            const Icon = role.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} className="p-8 rounded-3xl bg-white border shadow-sm" data-id="element-545">
                  <div className="mb-4" data-id="element-546">
                    <Icon className="w-7 h-7 text-dark" data-id="element-547" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2" data-id="element-548">{role.title}</h3>
                  <p className="text-gray-600" data-id="element-549">{role.description}</p>
                </motion.div>;
          })}
          </div>
        </div>

        {/* GURU */}
        <div data-id="element-550">
          <h2 className="text-3xl font-bold text-dark mb-8 text-center" data-id="element-551">
            Struktur BK
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-552">
            {teachers.map((teacher, index) => <motion.div key={index} className="p-6 bg-gray-50 rounded-2xl text-center" data-id="element-553">
                <UserCircle2 size={48} className="mx-auto mb-3 text-gray-400" data-id="element-554" />
                <h3 className="font-semibold" data-id="element-555">{teacher.name}</h3>
                <p className="text-sm text-gray-500" data-id="element-556">{teacher.role}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}